module.exports = __webpack_public_path__ + "industrial.jpg?4e8b22e4169d4568efd57524a059f523";